import { Link, useNavigate } from 'react-router-dom';
import StudyOption from './AdminData';
import './../../pagescss/Home.css';
import TopNavbar from '../home/TopNavbar';
import { useEffect, useState } from 'react';
import Loading from '../home/Loading';

function AdminHome() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [userData, setUserData] = useState({ phone: '', email: '' });

    useEffect(() => {
        const phoneFromStorage = localStorage.getItem('userPhone') || '';
        const emailFromStorage = localStorage.getItem('userEmail') || '';

        setUserData({ phone: phoneFromStorage, email: emailFromStorage });

        if (!phoneFromStorage) {
            navigate('/login');
            return;
        }

        const isAdminPhone = phoneFromStorage === "9339045904";
        const isAdminEmail = emailFromStorage === "sarwar93390@gmail.com";

        if (!isAdminPhone && !isAdminEmail) {
            navigate('/');
            return;
        }

        setIsAuthorized(true);
        setLoading(false);
    }, [navigate]);

    if (loading) {
        return <Loading />;
    }

    if (!isAuthorized) {
        return null; 
    }

    const studyOptions = StudyOption;
    const activeOptions = studyOptions.filter(option => option.status === "true");
    const name = "NEET PREP ADMIN";

    return (
        <div className="study-app">
            <TopNavbar name={name} />

            <header className="app-header">
                <h1>NEET PREP APP ADMIN</h1>
            </header>

            <div className="study-grid">
                {activeOptions.map((option) => (
                    <Link
                        to={option.link}
                        key={option.id}
                        className="study-card-link"
                    >
                        <div className="study-card">
                            <div className="card-icon">
                                <span style={{ fontSize: '70px' }}>
                                    {option.symbol}
                                </span>
                            </div>
                            <h3>{option.name}</h3>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default AdminHome;